/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CustomsMessaging = "DUTY_EXEMPT" | "NOT_DUTY_EXEMPT" | "NOT_ENOUGH_DATA" | "%future added value";
export type PdpSharedCustomsMessage_item = {
    readonly customsMessaging: {
        readonly message: string | null;
        readonly code: CustomsMessaging | null;
    } | null;
    readonly " $refType": "PdpSharedCustomsMessage_item";
};
export type PdpSharedCustomsMessage_item$data = PdpSharedCustomsMessage_item;
export type PdpSharedCustomsMessage_item$key = {
    readonly " $data"?: PdpSharedCustomsMessage_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCustomsMessage_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCustomsMessage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomsMessagingType",
      "kind": "LinkedField",
      "name": "customsMessaging",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'c11b7b73a27cef7a798d6bc1d233df6c';
export default node;
